import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["action", "children", "ariaLabel", "classes"];
import React from 'react';
import { func, node, shape, string } from 'prop-types';
import { useStyle } from '../../classify';
import defaultClasses from './trigger.module.css';
/**
 * A component that will trigger a given action.
 *
 * @typedef Trigger
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that when triggered invokes the action.
 */

var Trigger = function Trigger(props) {
  var action = props.action,
      children = props.children,
      ariaLabel = props.ariaLabel,
      propClasses = props.classes,
      restProps = _objectWithoutProperties(props, _excluded);

  var classes = useStyle(defaultClasses, propClasses);
  return React.createElement("button", _extends({
    className: classes.root,
    type: "button",
    onClick: action,
    "aria-label": ariaLabel
  }, restProps), children);
};
/**
 * Props for {@link Trigger}
 *
 * @typedef props
 *
 * @property {Function} action the handler for on the `onClick` event
 * handler.
 * @property {ReactNodeLike} children any elements that will be child
 * elements inside the root container.
 * @property {Object} classes An object containing the class names for the
 * Trigger component.
 * @property {string} classes.root classes for root container
 */


Trigger.propTypes = {
  action: func.isRequired,
  children: node,
  classes: shape({
    root: string
  })
};
export default Trigger;